// import store from '../vuex/store';
import Vue from 'vue';
// import $ from 'jquery';
/*
let mainMenuMap = {
    '^/web-mgr/project/check/pending': 'pending',
    '^/web-mgr/project/check/audit': 'audit',
    '^/web-mgr/project': 'project',
    '^/web-mgr/stat': 'stat',
    '^/web-mgr/material': 'material',
    '^/web-mgr/setting': 'setting'
};

let getMenuCode = (path) => {
    for(let p in mainMenuMap) {
        let regExp = new RegExp(p);
        if(regExp.test(path)) return mainMenuMap[p];
    }
    return 'home';
};

let hideMenuPages = [
  '^/web-mgr/material/video/create',
  '^/web-mgr/project/create',
  '^/web-mgr/project/create-contents'
];

let getIsHidePage = (path) => {
    for(let i = 0; i < hideMenuPages.length; i++) {
      let regExp = new RegExp(hideMenuPages[i]);
      if(regExp.test(path)) return true;
    }
    return false;
};*/

export default function(router) {

    router.afterEach(route => {

        setTimeout(function(){
            Vue.nextTick(function () {
                /*let $activeSubMenu = $('ul.page-sidebar-menu .sub-menu li.nav-item.active');

                // console.log($activeSubMenu.length);

                $('ul.page-sidebar-menu > .nav-item').removeClass('active');
                $activeSubMenu.parent().closest('.nav-item').addClass('active open');*/
            });
        }, 200);

        console.log(`成功浏览到: ${route.path}`)
        //$.refreshScroller()
        /*store.dispatch('CHANGE_MAIN_MENU', getMenuCode([to.path]));

        store.dispatch('CHANGE_MENU_HIDE', getIsHidePage(to.path));*/
    })
}
